/**
 * Store Scope:
 * - Set up global variables which can be accessible from somewhere else.
 */
document.addEventListener('alpine:init', () => {
    window.Alpine.store('priceSwitcherStore', {
        value: 'yearly',
    });
});

